import { render, staticRenderFns } from "./OtherDetailsModal.vue?vue&type=template&id=4a8a7cd5&scoped=true"
import script from "./OtherDetailsModal.vue?vue&type=script&lang=js"
export * from "./OtherDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./OtherDetailsModal.vue?vue&type=style&index=0&id=4a8a7cd5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8a7cd5",
  null
  
)

export default component.exports